var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ff-file-upload',{attrs:{"action":_vm.upload,"text":_vm.text || 'Upload an Image',"accept":'image/*',"type":_vm.type,"menu":_vm.menu}})}
var staticRenderFns = []

export { render, staticRenderFns }